/* eslint-disable object-shorthand */
/* eslint-disable quote-props */
/** THIS FILE IS GENERATED, DO NOT MODIFY */
import amenities from './modules/amenities';
import billingContacts from './modules/billing-contacts';
import billingProfile from './modules/billing-profile';
import billingReport from './modules/billing-report';
import bios from './modules/bios';
import blogs from './modules/blogs';
import buildingStackSyncSettings from './modules/building-stack-sync-settings';
import buildingsHasPhotos from './modules/buildings-has-photos';
import buildingsHasValidatedAddresses from './modules/buildings-has-validated-addresses';
import callTrackingAssociations from './modules/call-tracking-associations';
import callTrackingLogCalls from './modules/call-tracking-log-calls';
import callTrackingLogMessages from './modules/call-tracking-log-messages';
import callTrackingNumbers from './modules/call-tracking-numbers';
import callTrackingNumbersHasPartners from './modules/call-tracking-numbers-has-partners';
import callTrackingSettings from './modules/call-tracking-settings';
import callTrackingViews from './modules/call-tracking-views';
import careersPostings from './modules/careers-postings';
import changesSummary from './modules/changes-summary';
import cities from './modules/cities';
import citiesOffered from './modules/cities-offered';
import clientHasLanguages from './modules/client-has-languages';
import clientPromotedListings from './modules/client-promoted-listings';
import clientSyndicationSettings from './modules/client-syndication-settings';
import clientsDataSources from './modules/clients-data-sources';
import clientsHasContacts from './modules/clients-has-contacts';
import contacts from './modules/contacts';
import customContent from './modules/custom-content';
import disclaimer from './modules/disclaimer';
import documentCategories from './modules/document-categories';
import documents from './modules/documents';
import emailTracker from './modules/email-tracker';
import faqs from './modules/faqs';
import floorplanNavigatorInstanceBuildingHasFloors from './modules/floorplan-navigator-instance-building-has-floors';
import floorplanNavigatorInstanceFloors from './modules/floorplan-navigator-instance-floors';
import floorplanNavigatorInstanceHasBuildings from './modules/floorplan-navigator-instance-has-buildings';
import floorplanNavigatorInstancePointsOfInterest from './modules/floorplan-navigator-instance-points-of-interest';
import floorplanNavigatorInstancePointsOfInterestMedia from './modules/floorplan-navigator-instance-points-of-interest-media';
import floorplanNavigatorInstances from './modules/floorplan-navigator-instances';
import floorplanNavigatorInteractables from './modules/floorplan-navigator-interactables';
import floorplanNavigatorPresetButtons from './modules/floorplan-navigator-preset-buttons';
import floorplanNavigatorPresetCardGroups from './modules/floorplan-navigator-preset-card-groups';
import floorplanNavigatorPresetFields from './modules/floorplan-navigator-preset-fields';
import floorplanNavigatorPresetFilters from './modules/floorplan-navigator-preset-filters';
import floorplanNavigatorPresetForms from './modules/floorplan-navigator-preset-forms';
import floorplanNavigatorPresetModalTabs from './modules/floorplan-navigator-preset-modal-tabs';
import floorplanNavigatorPresets from './modules/floorplan-navigator-presets';
import formResponses from './modules/form-responses';
import formSettings from './modules/form-settings';
import formSubmissions from './modules/form-submissions';
import formSubmissionsReadonly from './modules/form-submissions-readonly';
import importerFields from './modules/importer-fields';
import inquiries from './modules/inquiries';
import internalNotifications from './modules/internal-notifications';
import invoices from './modules/invoices';
import ivrCallGroups from './modules/ivr-call-groups';
import leads from './modules/leads';
import leadsIngest from './modules/leads-ingest';
import leadsNew from './modules/leads-new';
import liftNewsFeed from './modules/lift-news-feed';
import liftNewsFeedClicks from './modules/lift_news_feed_clicks';
import liftSettings from './modules/lift-settings';
import liftSubscriptions from './modules/lift-subscriptions';
import listingFloorplans from './modules/listing-floorplans';
import listingManagementPropertyOverrides from './modules/listing-management-property-overrides';
import listingPhotos from './modules/listing-photos';
import listingScores from './modules/listing-scores';
import listingVideos from './modules/listing-videos';
import listingVirtualTours from './modules/listing-virtualTours';
import main from './modules/main';
import maintenance from './modules/maintenance';
import mapSettings from './modules/map-settings';
import menuPages from './modules/menu-pages';
import modal from './modules/modal';
import news from './modules/news';
import objectsHasTags from './modules/objects-has-tags';
import openAiLogFeedback from './modules/open-ai-log-feedback';
import openAiLogs from './modules/open-ai-logs';
import openAiSavedDescriptions from './modules/open-ai-saved-descriptions';
import outboundNotifications from './modules/outbound-notifications';
import outstandingInvoices from './modules/outstanding-invoices';
import pages from './modules/pages';
import panelTemplateGroups from './modules/panel-template-groups';
import panelTemplateHasModels from './modules/panel-template-has-models';
import panelTemplates from './modules/panel-templates';
import partnerInquiries from './modules/partner-inquiries';
import partners from './modules/partners';
import permsApiClientUsers from './modules/perms-api-client-users';
import permsApiGroups from './modules/perms-api-groups';
import permsApiGroupsHasProducts from './modules/perms-api-groups-has-products';
import permsApiGroupsHasUsers from './modules/perms-api-groups-has-users';
import permsApiProducts from './modules/perms-api-products';
import permsApiProductsHasClients from './modules/perms-api-products-has-clients';
import platformSearches from './modules/platform-searches';
import posts from './modules/posts';
import premiumReportingCitiesBaseSubscriptions from './modules/premium-reporting-cities-base-subscriptions';
import premiumReportingClientCities from './modules/premium-reporting-client-cities';
import promotedListingTypes from './modules/promoted-listing-types';
import promotedListings from './modules/promoted-listings';
import promotions from './modules/promotions';
import promotionsCategories from './modules/promotions-categories';
import promotionsExample from './modules/promotions-example';
import properties from './modules/properties';
import propertiesSyndication from './modules/properties-syndication';
import propertyAmenities from './modules/property-amenities';
import propertyIvrSettings from './modules/property-ivr-settings';
import propertyMedia from './modules/property-media';
import propertySearchBuilderDataFilters from './modules/property-search-builder-data-filters';
import propertySearchBuilderFields from './modules/property-search-builder-fields';
import propertySearchBuilderInstances from './modules/property-search-builder-instances';
import propertySearchBuilderSorts from './modules/property-search-builder-sorts';
import propertySearchBuilderUiFilters from './modules/property-search-builder-ui-filters';
import regions from './modules/regions';
import rentAnalyzer from './modules/rent-analyzer';
import rentsyncProperties from './modules/rentsync-properties';
import rentsyncPropertiesMeta from './modules/rentsync-properties-meta';
import rentsyncSettingsConfig from './modules/rentsync-settings-config';
import rentsyncTrackingItems from './modules/rentsync-tracking-items';
import settingsHasPartners from './modules/settings-has-partners';
import siteMetaTags from './modules/site-meta-tags';
import sitesHasFloorplanNavigatorInstances from './modules/sites-has-floorplan-navigator-instances';
import sitesHasLanguages from './modules/sites-has-languages';
import suiteTypesAdditionalSettings from './modules/suite-types-additional-settings';
import syndicationSettings from './modules/syndication-settings';
import tags from './modules/tags';
import testimonials from './modules/testimonials';
import tourBookingAgentCsv from './modules/tour-booking-agent-csv';
import tourBookingResponses from './modules/tour-booking-responses';
import tourBuildingSettings from './modules/tour-building-settings';
import tourClientSettings from './modules/tour-client-settings';
import tourFormSettings from './modules/tour-form-settings';
import tourNylasAccounts from './modules/tour-nylas-accounts';
import tourNylasCalendars from './modules/tour-nylas-calendars';
import tourUserAvailabilities from './modules/tour-user-availabilities';
import tourUserExceptions from './modules/tour-user-exceptions';
import tourUserSettings from './modules/tour-user-settings';
import tourUsersHasBuildings from './modules/tour-users-has-buildings';
import unitAssignedPhotos from './modules/unit-assigned-photos';
import unitFloorplans from './modules/unit-floorplans';
import unitListBuilder from './modules/unit-list-builder';
import unitListBuilderFields from './modules/unit-list-builder-fields';
import unitListBuilderFilters from './modules/unit-list-builder-filters';
import unitListBuilderForms from './modules/unit-list-builder-forms';
import unitListBuilderSorts from './modules/unit-list-builder-sorts';
import unitMedia from './modules/unit-media';
import unitModels from './modules/unit-models';
import unitPhotos from './modules/unit-photos';
import units from './modules/units';
import userHasDisclaimers from './modules/user-has-disclaimers';
import users from './modules/users';
import utilities from './modules/utilities';
import validatedAddresses from './modules/validated-addresses';
import validationSummary from './modules/validation-summary';
import videos from './modules/videos';
import virtualTours from './modules/virtual-tours';
import waitingLists from './modules/waiting-lists';
import webhooks from './modules/webhooks';
import websites from './modules/websites';
import workflowEvents from './modules/workflow-events';

export const modules: Record<string, any> = {
  'amenities': amenities,
  'billing-contacts': billingContacts,
  'billing-profile': billingProfile,
  'billing-report': billingReport,
  'bios': bios,
  'blogs': blogs,
  'building-stack-sync-settings': buildingStackSyncSettings,
  'buildings-has-photos': buildingsHasPhotos,
  'buildings-has-validated-addresses': buildingsHasValidatedAddresses,
  'call-tracking-associations': callTrackingAssociations,
  'call-tracking-log-calls': callTrackingLogCalls,
  'call-tracking-log-messages': callTrackingLogMessages,
  'call-tracking-numbers': callTrackingNumbers,
  'call-tracking-numbers-has-partners': callTrackingNumbersHasPartners,
  'call-tracking-settings': callTrackingSettings,
  'call-tracking-views': callTrackingViews,
  'careers-postings': careersPostings,
  'changes-summary': changesSummary,
  'cities': cities,
  'cities-offered': citiesOffered,
  'client-has-languages': clientHasLanguages,
  'client-promoted-listings': clientPromotedListings,
  'client-syndication-settings': clientSyndicationSettings,
  'clients-data-sources': clientsDataSources,
  'clients-has-contacts': clientsHasContacts,
  'contacts': contacts,
  'custom-content': customContent,
  'disclaimer': disclaimer,
  'document-categories': documentCategories,
  'documents': documents,
  'email-tracker': emailTracker,
  'faqs': faqs,
  'floorplan-navigator-instance-building-has-floors': floorplanNavigatorInstanceBuildingHasFloors,
  'floorplan-navigator-instance-floors': floorplanNavigatorInstanceFloors,
  'floorplan-navigator-instance-has-buildings': floorplanNavigatorInstanceHasBuildings,
  'floorplan-navigator-instance-points-of-interest': floorplanNavigatorInstancePointsOfInterest,
  'floorplan-navigator-instance-points-of-interest-media': floorplanNavigatorInstancePointsOfInterestMedia,
  'floorplan-navigator-instances': floorplanNavigatorInstances,
  'floorplan-navigator-interactables': floorplanNavigatorInteractables,
  'floorplan-navigator-preset-buttons': floorplanNavigatorPresetButtons,
  'floorplan-navigator-preset-card-groups': floorplanNavigatorPresetCardGroups,
  'floorplan-navigator-preset-fields': floorplanNavigatorPresetFields,
  'floorplan-navigator-preset-filters': floorplanNavigatorPresetFilters,
  'floorplan-navigator-preset-forms': floorplanNavigatorPresetForms,
  'floorplan-navigator-preset-modal-tabs': floorplanNavigatorPresetModalTabs,
  'floorplan-navigator-presets': floorplanNavigatorPresets,
  'form-responses': formResponses,
  'form-settings': formSettings,
  'form-submissions': formSubmissions,
  'form-submissions-readonly': formSubmissionsReadonly,
  'importer-fields': importerFields,
  'inquiries': inquiries,
  'internal-notifications': internalNotifications,
  'invoices': invoices,
  'ivr-call-groups': ivrCallGroups,
  'leads': leads,
  'leads-ingest': leadsIngest,
  'leads-new': leadsNew,
  'lift-news-feed': liftNewsFeed,
  'lift-settings': liftSettings,
  'lift-subscriptions': liftSubscriptions,
  'lift_news_feed_clicks': liftNewsFeedClicks,
  'listing-floorplans': listingFloorplans,
  'listing-management-property-overrides': listingManagementPropertyOverrides,
  'listing-photos': listingPhotos,
  'listing-scores': listingScores,
  'listing-videos': listingVideos,
  'listing-virtualTours': listingVirtualTours,
  'main': main,
  'maintenance': maintenance,
  'map-settings': mapSettings,
  'menu-pages': menuPages,
  'modal': modal,
  'news': news,
  'objects-has-tags': objectsHasTags,
  'open-ai-log-feedback': openAiLogFeedback,
  'open-ai-logs': openAiLogs,
  'open-ai-saved-descriptions': openAiSavedDescriptions,
  'outbound-notifications': outboundNotifications,
  'outstanding-invoices': outstandingInvoices,
  'pages': pages,
  'panel-template-groups': panelTemplateGroups,
  'panel-template-has-models': panelTemplateHasModels,
  'panel-templates': panelTemplates,
  'partner-inquiries': partnerInquiries,
  'partners': partners,
  'perms-api-client-users': permsApiClientUsers,
  'perms-api-groups': permsApiGroups,
  'perms-api-groups-has-products': permsApiGroupsHasProducts,
  'perms-api-groups-has-users': permsApiGroupsHasUsers,
  'perms-api-products': permsApiProducts,
  'perms-api-products-has-clients': permsApiProductsHasClients,
  'platform-searches': platformSearches,
  'posts': posts,
  'premium-reporting-cities-base-subscriptions': premiumReportingCitiesBaseSubscriptions,
  'premium-reporting-client-cities': premiumReportingClientCities,
  'promoted-listing-types': promotedListingTypes,
  'promoted-listings': promotedListings,
  'promotions': promotions,
  'promotions-categories': promotionsCategories,
  'promotions-example': promotionsExample,
  'properties': properties,
  'properties-syndication': propertiesSyndication,
  'property-amenities': propertyAmenities,
  'property-ivr-settings': propertyIvrSettings,
  'property-media': propertyMedia,
  'property-search-builder-data-filters': propertySearchBuilderDataFilters,
  'property-search-builder-fields': propertySearchBuilderFields,
  'property-search-builder-instances': propertySearchBuilderInstances,
  'property-search-builder-sorts': propertySearchBuilderSorts,
  'property-search-builder-ui-filters': propertySearchBuilderUiFilters,
  'regions': regions,
  'rent-analyzer': rentAnalyzer,
  'rentsync-properties': rentsyncProperties,
  'rentsync-properties-meta': rentsyncPropertiesMeta,
  'rentsync-settings-config': rentsyncSettingsConfig,
  'rentsync-tracking-items': rentsyncTrackingItems,
  'settings-has-partners': settingsHasPartners,
  'site-meta-tags': siteMetaTags,
  'sites-has-floorplan-navigator-instances': sitesHasFloorplanNavigatorInstances,
  'sites-has-languages': sitesHasLanguages,
  'suite-types-additional-settings': suiteTypesAdditionalSettings,
  'syndication-settings': syndicationSettings,
  'tags': tags,
  'testimonials': testimonials,
  'tour-booking-agent-csv': tourBookingAgentCsv,
  'tour-booking-responses': tourBookingResponses,
  'tour-building-settings': tourBuildingSettings,
  'tour-client-settings': tourClientSettings,
  'tour-form-settings': tourFormSettings,
  'tour-nylas-accounts': tourNylasAccounts,
  'tour-nylas-calendars': tourNylasCalendars,
  'tour-user-availabilities': tourUserAvailabilities,
  'tour-user-exceptions': tourUserExceptions,
  'tour-user-settings': tourUserSettings,
  'tour-users-has-buildings': tourUsersHasBuildings,
  'unit-assigned-photos': unitAssignedPhotos,
  'unit-floorplans': unitFloorplans,
  'unit-list-builder': unitListBuilder,
  'unit-list-builder-fields': unitListBuilderFields,
  'unit-list-builder-filters': unitListBuilderFilters,
  'unit-list-builder-forms': unitListBuilderForms,
  'unit-list-builder-sorts': unitListBuilderSorts,
  'unit-media': unitMedia,
  'unit-models': unitModels,
  'unit-photos': unitPhotos,
  'units': units,
  'user-has-disclaimers': userHasDisclaimers,
  'users': users,
  'utilities': utilities,
  'validated-addresses': validatedAddresses,
  'validation-summary': validationSummary,
  'videos': videos,
  'virtual-tours': virtualTours,
  'waiting-lists': waitingLists,
  'webhooks': webhooks,
  'websites': websites,
  'workflow-events': workflowEvents,
};
